import React, { FC, memo } from "react";
import { getChartXIntervals, iViewBoxProps } from "./SummaryChart.helpers";

const ChartAxisX: FC<{
    labels: string[];
    viewport: iViewBoxProps;
}> = (
    {
        labels,
        viewport,
    }
) => {
    const intervals = getChartXIntervals({
        dataLength: labels.length,
        viewport,
    })

    return (
        <g
            name="axis-x"
            className="FoodSummaryChart__axis"
            style={{
                transform: `translateY(${viewport.height}px)`,
            }}
            data-testid={`textChartAxisX`}
        >
            {labels.map((label, index) => {
                return (
                    <React.Fragment key={index}>
                        <text
                            key={index}
                            x={intervals[index]}
                            y={12}
                            fill="#fff"
                            textAnchor="middle"
                            alignmentBaseline="middle"
                            data-testid={`textChartAxisXLabel${index}`}
                        >
                            {label}
                        </text>
                    </React.Fragment>
                )
            })}
        </g>
    );
};

export default memo(ChartAxisX);